import { render, staticRenderFns } from "./LogoutPageAdsTab.vue?vue&type=template&id=feb7e712"
import script from "./LogoutPageAdsTab.vue?vue&type=script&lang=js"
export * from "./LogoutPageAdsTab.vue?vue&type=script&lang=js"
import style0 from "./asset-split.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports